import { useRef, useState } from 'react'
import { SBack, SFuncModal, SLowcodeList } from 'shj-components'
import config from './config.json'
import { useNavigate } from 'react-router-dom'
import Add from './add'
import { projectExternalEmployeeList, syncOutsourcingSyncKd } from '@/services/externalPerson'
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons'
import { getEnums, searchCompanyList } from '@/services/homeService'
import { getWorkTypeList } from '@/services'
import { authDict, getUser } from 'shj-utils'
import { Flex, QRCode, Typography, Button, message } from 'antd'
import { useSetState } from 'ahooks'

const AccountList = () => {
  const listRef = useRef<any>()
  const [visibleDrawer, setVisibleDrawer] = useState(false)
  const [detailInfo, setDetailInfo] = useState<any>()
  const [state, setState] = useSetState<any>({
    syncLoadingId: '',
  })
  const history = useNavigate()
  const fetchList = (values: any) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        if (query.actStatus) query.actStatus = query.actStatus * 1
        projectExternalEmployeeList(current, pageSize, query).then(data => {
          resolve(data)
        })
      } catch (e) {
        reject({ success: false })
      }
    })
  }

  const getStatusOptions = () => {
    return new Promise(async resolve => {
      try {
        const extWorkerStatusEnum = await getEnums(
          'plus-pm',
          'com.shj.saas.plus.pm.domain.worker.enums.ExtWorkerStatusEnum'
        )
        const workTypeList = await getWorkTypeList()
        const companyList: any = await searchCompanyList()
        const allCompanyList: any = await searchCompanyList({ status: '' })
        resolve({
          extWorkerStatusEnum,
          companyList: companyList,
          allCompanyList: allCompanyList,
          workTypeList: workTypeList,
        })
      } catch (e) {
        console.log(e)
      }
    })
  }

  const toDetail = record => {
    history('/config/serviceConfig/externalPerson/detail/' + record.id)
  }
  const onAdd = () => {
    setDetailInfo({})
    setVisibleDrawer(true)
  }
  const onAddUser = () => {
    const user = getUser()
    const query = decodeURIComponent(
      `tenantId=${user.tenantId}&companyId=${user.companyId}&companyName=${user.companyName}&ucenterUserId=${user.ucenterUserId}`
    )
    const url = window.location.origin + `/h5/#/pages/deliver/register/external?${query}`
    SFuncModal({
      title: '邀请外协人员注册',
      width: 500,
      okText: '关闭',
      cancel: false,
      content: (
        <Flex justify="center" align="center" vertical={true}>
          <QRCode value={url} />
          <Typography.Paragraph style={{ marginTop: '10px' }} copyable={{ text: url }}>
            外协人员注册(链接)
          </Typography.Paragraph>
        </Flex>
      ),
    })
  }

  const closeDetails = () => {
    setVisibleDrawer(false)
  }
  const reloadList = () => {
    listRef.current?.reload()
  }
  const changeLookAuth = record => {
    record.phoneAuth = !record.phoneAuth
    let list = listRef.current?.getDataSource()
    for (let m of list) {
      if (m.id === record.id) {
        m.phoneAuth = record.phoneAuth
      }
    }
    listRef.current?.updateDataSource(list || [])
  }

  const onSyncKd = record => {
    // console.log('record', record)
    setState({
      syncLoadingId: record.id,
    })
    syncOutsourcingSyncKd({
      userCode: record.extCode,
    })
      .then((res: any) => {
        if (res.message) {
          message.success(res.message)
        }
        reloadList()
      })
      .finally(() => {
        setState({
          syncLoadingId: '',
        })
      })
  }

  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onAdd, onAddUser },
    searchFormConfig: {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    },
    customRender: {
      extCodeRender(text: any, record: any) {
        return authDict['externalPersonViewDetail'] ? (
          <div onClick={() => toDetail(record)} style={{ color: '#1677ff', cursor: 'pointer' }}>
            {text}
          </div>
        ) : (
          <div>{text}</div>
        )
      },
      phoneRender(text: string, record: any) {
        return (
          <div>
            {record.phoneAuth ? (
              <>
                <span> {record.phone}</span>{' '}
                <EyeOutlined onClick={() => changeLookAuth(record)} style={{ cursor: 'pointer' }} />
              </>
            ) : (
              <>
                <span>{record.phoneHide} </span>{' '}
                <EyeInvisibleOutlined
                  onClick={() => changeLookAuth(record)}
                  style={{ cursor: 'pointer' }}
                />
              </>
            )}
          </div>
        )
      },

      optRender(_: string, record: any) {
        return record['kdStatus'] == 'E' ? (
          <Button
            type="primary"
            ghost
            onClick={() => onSyncKd(record)}
            disabled={state.syncLoadingId === record.id}
          >
            同步金蝶
          </Button>
        ) : null
      },
    },
  }

  return (
    <>
      <SBack title={`工人管理`}></SBack>
      <SLowcodeList config={config} ref={listRef} {...extension} searchMode="group" />
      <Add
        record={detailInfo}
        visibleDrawer={visibleDrawer}
        closeDetails={closeDetails}
        reloadList={reloadList}
      ></Add>
    </>
  )
}

function AccountListPage(props: any) {
  return (
    <>
      <AccountList {...props} />
    </>
  )
}

export default AccountListPage
